export class DadosContratosModel {

    public titulo: string;
    public contrato: string;
    public desPerfil: string;
    public razaoSocial: String;
    public inscricao: string;
    public tipoInscricao: string;
    public servicos: string [];
    public tipoContrato: string; //Restrito ou Amplo
    public isRenovacao: boolean;
    public tipoNovoContrato: string;
}